window.fungiAccordionControllers = window.fungiAccordionControllers || {};

function initFungiAccordion(sectionId) {
  try {
    const containerId = 'FungiAccordion-' + sectionId;
    const accordionContainer = document.getElementById(containerId);
    
    if (!accordionContainer) return;

    if (window.fungiAccordionControllers[sectionId]) {
      window.fungiAccordionControllers[sectionId].abort();
    }
    
    const controller = new AbortController();
    window.fungiAccordionControllers[sectionId] = controller;
    const signal = controller.signal;
    
    const items = accordionContainer.querySelectorAll('.fungi-accordion-item');
    const mediaQuery = window.matchMedia('(min-width: 769px)');

    if (!mediaQuery.matches) {
      items.forEach(i => i.setAttribute('aria-expanded', 'true'));
    }

    function handleActivation(activeItem) {
      if (!mediaQuery.matches) return; 
      items.forEach(i => {
        i.classList.remove('is-active');
        i.setAttribute('aria-expanded', 'false');
      });
      activeItem.classList.add('is-active');
      activeItem.setAttribute('aria-expanded', 'true');
    }

    items.forEach(item => {
      item.addEventListener('mouseenter', () => handleActivation(item), { signal });
      item.addEventListener('focus', () => handleActivation(item), { signal });
      
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleActivation(item);
        }
      }, { signal });
    });

    mediaQuery.addEventListener('change', (e) => {
      if (!e.matches) {
        items.forEach(i => i.setAttribute('aria-expanded', 'true'));
      } else {
        items.forEach((item, index) => {
          if (index === 0) {
            item.classList.add('is-active');
            item.setAttribute('aria-expanded', 'true');
          } else {
            item.classList.remove('is-active');
            item.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }, { signal });
  } catch (error) {
    console.error("Fungi Pharma: Error al inicializar el acordeón", error);
  }
}

function initAllFungiAccordions() {
  const accordions = document.querySelectorAll('.fungi-accordion-container');
  accordions.forEach(acc => {
    const sectionId = acc.id.replace('FungiAccordion-', '');
    initFungiAccordion(sectionId);
  });
}

// Inicialización de la página web
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllFungiAccordions);
} else {
  initAllFungiAccordions();
}

// Integración con Theme Editor
document.addEventListener('shopify:section:load', function(event) {
  initFungiAccordion(event.detail.sectionId);
});

document.addEventListener('shopify:section:select', function(event) {
  const isInitialized = window.fungiAccordionControllers && window.fungiAccordionControllers[event.detail.sectionId];
  if (!isInitialized) initFungiAccordion(event.detail.sectionId);
});

document.addEventListener('shopify:section:deselect', function(event) {
  const accordionContainer = document.getElementById('FungiAccordion-' + event.detail.sectionId);
  if (accordionContainer && window.matchMedia('(min-width: 769px)').matches) {
    const items = accordionContainer.querySelectorAll('.fungi-accordion-item');
    if (items.length > 0) {
      items.forEach(i => {
        i.classList.remove('is-active');
        i.setAttribute('aria-expanded', 'false');
      });
      items[0].classList.add('is-active');
      items[0].setAttribute('aria-expanded', 'true');
    }
  }
});